import { Divider, withProps, Box, Stack } from '@cast/design-system';

import { KindQuickSearch } from '../../../_workloads-list/components/KindQuickSearch';
import { NamespacesFilter } from '../../../_workloads-list/components/NamespacesFilter';
import {
  ConfiguredViaQuickSearch,
  HorizontalOptimizationQuickSearch,
  VerticalOptimizationQuickSearch,
} from '../../../workloads-list/TableSection/_components/WoopQuickSearch/_components';
import {
  ClearAllButton,
  QuickSearch,
  QuickSearchGroup,
  Search,
} from '@cast/shared-search-ui';

const StyledDivider = withProps(Divider, {
  orientation: 'vertical',
  color: 'grey.300',
  sx: { mx: 4, height: 24, alignSelf: 'flex-end' },
});

export const Filters = () => {
  return (
    <Stack gap={8} data-testid="filters">
      <Box display="grid" gridTemplateColumns="1fr 220px auto" columnGap={8}>
        <Search size="small" />
        <NamespacesFilter optimizedOnly />
        <ClearAllButton size="sm" />
      </Box>

      <QuickSearch defaultOpen>
        <QuickSearchGroup label="Vertical">
          <VerticalOptimizationQuickSearch />
        </QuickSearchGroup>
        <StyledDivider />
        <QuickSearchGroup label="Horizontal">
          <HorizontalOptimizationQuickSearch />
        </QuickSearchGroup>
        <StyledDivider />
        <QuickSearchGroup label="Configured by">
          <ConfiguredViaQuickSearch />
        </QuickSearchGroup>
        <StyledDivider />
        <QuickSearchGroup label="Kind">
          <KindQuickSearch optimizedOnly />
        </QuickSearchGroup>
      </QuickSearch>
    </Stack>
  );
};
